import { z } from "zod";
import { ZodStringNullable } from "../zod-types/zod-string-nullable";

/**
 * What the form posts. Neither the booking's record nor the answer's booking is named here: the
 * record is the one the route's path names, and the answer belongs to the booking it is nested
 * under, so the handler writes both ids from there and a copy in the body would be one it had
 * to distrust. The read shape (`Bookings` in `@msuite/utils/types`) is the row and keeps both.
 */
export const assignmentReferenceSingleBookingAdjustmentSchema = z.object({
	id: z.string().uuid(),
	checkIn: z.string().nullable(),
	checkOut: z.string().nullable(),
	pause: z.number().min(0).max(24).nullable(),
	result: z.string().nullable(),
	note: ZodStringNullable,
});

export const assignmentReferenceSingleBookingSchema = z.object({
	id: z.string().uuid(),
	checkIn: z.string(),
	checkOut: z.string(),
	ranking: z.number(),
	userId: z.string().nullable(),
	pause: z.number().min(0).max(24),
	note: z.string().nullable(),
	adjustment: assignmentReferenceSingleBookingAdjustmentSchema.nullable(),
});

export const assignmentReferenceBookingsSchema = z.object({
	bookings: z.array(assignmentReferenceSingleBookingSchema),
});

export type AssignmentReferenceBookingsSchema = z.infer<typeof assignmentReferenceBookingsSchema>;

/**
 * What a save sends: the form's bookings, and the version of the record they were read at. The
 * version is not a form field — the form never edits it — so it rides beside the form's values
 * rather than inside its schema.
 */
export const postAssignmentReferenceBookingsSchema = assignmentReferenceBookingsSchema.extend({
	version: z.string(),
});

export type PostAssignmentReferenceBookingsSchema = z.infer<
	typeof postAssignmentReferenceBookingsSchema
>;
export type AssignmentReferenceSingleBookingAdjustmentSchema = z.infer<
	typeof assignmentReferenceSingleBookingAdjustmentSchema
>;
export type AssignmentReferenceSingleBookingSchema = z.infer<
	typeof assignmentReferenceSingleBookingSchema
>;
